var map = {
	"./404.png": [
		93262,
		3262
	],
	"./Assets/Home.png": [
		76905,
		6905
	],
	"./Assets/Login.png": [
		7405,
		7405
	],
	"./Assets/SignUp.png": [
		52184,
		2184
	],
	"./Assets/Tree and seeds/MacBook Air - 1.png": [
		34626,
		4626
	],
	"./Assets/Tree and seeds/MacBook Air - 10.png": [
		44088,
		4088
	],
	"./Assets/Tree and seeds/MacBook Air - 11.png": [
		65217,
		5217
	],
	"./Assets/Tree and seeds/MacBook Air - 12.png": [
		7786,
		7786
	],
	"./Assets/Tree and seeds/MacBook Air - 13.png": [
		39699,
		9699
	],
	"./Assets/Tree and seeds/MacBook Air - 14.png": [
		42300,
		2300
	],
	"./Assets/Tree and seeds/MacBook Air - 15.png": [
		78213,
		8213
	],
	"./Assets/Tree and seeds/MacBook Air - 16.png": [
		66734,
		6734
	],
	"./Assets/Tree and seeds/MacBook Air - 17.png": [
		49879,
		9879
	],
	"./Assets/Tree and seeds/MacBook Air - 18.png": [
		33520,
		3520
	],
	"./Assets/Tree and seeds/MacBook Air - 2.png": [
		64985,
		4985
	],
	"./Assets/Tree and seeds/MacBook Air - 3.png": [
		32880,
		2880
	],
	"./Assets/Tree and seeds/MacBook Air - 4.png": [
		67484,
		5103
	],
	"./Assets/Tree and seeds/MacBook Air - 5.png": [
		60006,
		6
	],
	"./Assets/Tree and seeds/MacBook Air - 6.png": [
		43773,
		3773
	],
	"./Assets/Tree and seeds/MacBook Air - 7.png": [
		22644,
		2644
	],
	"./Assets/Tree and seeds/MacBook Air - 8.png": [
		17939,
		7939
	],
	"./Assets/Tree and seeds/MacBook Air - 9.png": [
		67178,
		7178
	],
	"./Assets/leaf.png": [
		92740,
		2740
	],
	"./access.png": [
		62786,
		2786
	],
	"./amordad.png": [
		46206,
		6206
	],
	"./back.jpg": [
		59925,
		9925
	],
	"./bemLogo.png": [
		3515,
		3515
	],
	"./blogs/bcn.jpg": [
		53701,
		3701
	],
	"./blogs/benefits/cta1.jpg": [
		20992,
		992
	],
	"./blogs/benefits/cta2.jpg": [
		34607,
		4607
	],
	"./blogs/benefits/cta3.jpg": [
		66674,
		6674
	],
	"./blogs/goals.jpg": [
		23016,
		3016
	],
	"./blogs/header.jpg": [
		51845,
		1845
	],
	"./blogs/icons/debt.svg": [
		74804,
		4804
	],
	"./blogs/icons/equity.svg": [
		4230,
		4230
	],
	"./blogs/icons/financialAssistance.svg": [
		46780,
		6780
	],
	"./blogs/icons/reward.svg": [
		39534,
		9534
	],
	"./blogs/logos/bcn.png": [
		10568,
		568
	],
	"./blogs/logos/bem.png": [
		75445,
		5445
	],
	"./blogs/logos/bemchain.png": [
		10846,
		846
	],
	"./blogs/logos/bemex.png": [
		43694,
		3694
	],
	"./blogs/logos/bemgames.png": [
		90240,
		240
	],
	"./blogs/logos/bemib.png": [
		48848,
		8848
	],
	"./blogs/logos/bempay.png": [
		78343,
		8343
	],
	"./blogs/logos/bempire.png": [
		54731,
		4731
	],
	"./blogs/logos/bemulator.png": [
		7842,
		7842
	],
	"./blogs/logos/tim.png": [
		79643,
		9643
	],
	"./blogs/marketmaker.jpg": [
		74208,
		4208
	],
	"./blogs/mmpworld.jpg": [
		5368,
		5368
	],
	"./blogs/risks.jpg": [
		57768,
		7768
	],
	"./buildings/amordadShop.png": [
		77992,
		7992
	],
	"./buildings/fire.png": [
		96994,
		6994
	],
	"./buildings/fruitMarket.png": [
		7330,
		7330
	],
	"./buildings/spellFactory.png": [
		31806,
		1806
	],
	"./buildings/spring.png": [
		70785,
		785
	],
	"./buildings/warehouse_0.png": [
		11844,
		1844
	],
	"./buildings/warehouse_1.png": [
		68141,
		8141
	],
	"./buildings/warehouse_2.png": [
		86518,
		6518
	],
	"./buildings/warehouse_3.png": [
		66495,
		6495
	],
	"./buildings/warehouse_4.png": [
		15168,
		5168
	],
	"./buildings/warehouse_5.png": [
		86345,
		6345
	],
	"./chars/bdwarf001.png": [
		43071,
		3071
	],
	"./chars/bdwarf002.png": [
		13156,
		3156
	],
	"./chars/bdwarf002w.png": [
		57937,
		7937
	],
	"./chars/bdwarf003.png": [
		55661,
		5661
	],
	"./chars/bhawnthorn001.png": [
		78328,
		8328
	],
	"./chars/bhawnthorn002.png": [
		52819,
		2819
	],
	"./chars/bhawnthorn002w.png": [
		25764,
		5764
	],
	"./chars/bhawnthorn003.png": [
		13962,
		3962
	],
	"./chars/bkerala001.png": [
		73519,
		3519
	],
	"./chars/bkerala002.png": [
		54612,
		4612
	],
	"./chars/bkerala002w.png": [
		94145,
		4145
	],
	"./chars/bkerala003.png": [
		75741,
		5741
	],
	"./chars/bkhotan001.png": [
		68502,
		8502
	],
	"./chars/bkhotan002.png": [
		269,
		269
	],
	"./chars/bkhotan002w.png": [
		13382,
		3382
	],
	"./chars/bkhotan003.png": [
		20676,
		676
	],
	"./chars/bpitaya001.png": [
		17031,
		7031
	],
	"./chars/bpitaya002.png": [
		66348,
		6348
	],
	"./chars/bpitaya002w.png": [
		7753,
		7753
	],
	"./chars/bpitaya003.png": [
		77973,
		7973
	],
	"./chars/btfg001.png": [
		68828,
		8828
	],
	"./chars/btfg002.png": [
		57559,
		7559
	],
	"./chars/btfg002w.png": [
		98744,
		8744
	],
	"./chars/btfg003.png": [
		83918,
		3918
	],
	"./chars/dwarf001.png": [
		75631,
		5631
	],
	"./chars/dwarf002.png": [
		70516,
		516
	],
	"./chars/dwarf002w.png": [
		38241,
		8241
	],
	"./chars/dwarf003.png": [
		91645,
		1645
	],
	"./chars/dwarf003w.png": [
		16438,
		6438
	],
	"./chars/dwarf004.png": [
		29922,
		9922
	],
	"./chars/dwarf004w.png": [
		38839,
		8839
	],
	"./chars/dwarf005.png": [
		20427,
		427
	],
	"./chars/hawnthorn001.png": [
		5256,
		5256
	],
	"./chars/hawnthorn002.png": [
		67235,
		7235
	],
	"./chars/hawnthorn002w.png": [
		20564,
		564
	],
	"./chars/hawnthorn003.png": [
		77402,
		7402
	],
	"./chars/hawnthorn003w.png": [
		69932,
		7551
	],
	"./chars/hawnthorn004.png": [
		29461,
		9461
	],
	"./chars/hawnthorn004w.png": [
		91742,
		1742
	],
	"./chars/hawnthorn005.png": [
		17836,
		7836
	],
	"./chars/kerala001.png": [
		70175,
		175
	],
	"./chars/kerala002.png": [
		40260,
		260
	],
	"./chars/kerala002w.png": [
		14801,
		4801
	],
	"./chars/kerala003.png": [
		82765,
		2765
	],
	"./chars/kerala003w.png": [
		61606,
		1606
	],
	"./chars/kerala004.png": [
		1202,
		1202
	],
	"./chars/kerala004w.png": [
		90695,
		695
	],
	"./chars/kerala005.png": [
		50203,
		203
	],
	"./chars/khotan001.png": [
		26726,
		6726
	],
	"./chars/khotan002.png": [
		51613,
		1613
	],
	"./chars/khotan002w.png": [
		18966,
		8966
	],
	"./chars/khotan003.png": [
		30484,
		484
	],
	"./chars/khotan003w.png": [
		17089,
		7089
	],
	"./chars/khotan004.png": [
		76395,
		6395
	],
	"./chars/khotan004w.png": [
		70604,
		604
	],
	"./chars/khotan005.png": [
		55266,
		5266
	],
	"./chars/pitaya001.png": [
		67511,
		7511
	],
	"./chars/pitaya002.png": [
		66876,
		6876
	],
	"./chars/pitaya002w.png": [
		14745,
		4745
	],
	"./chars/pitaya003.png": [
		96293,
		6293
	],
	"./chars/pitaya003w.png": [
		97102,
		7102
	],
	"./chars/pitaya004.png": [
		11626,
		1626
	],
	"./chars/pitaya004w.png": [
		35983,
		5983
	],
	"./chars/pitaya005.png": [
		50483,
		483
	],
	"./chars/tfg001.png": [
		43532,
		3532
	],
	"./chars/tfg002.png": [
		94215,
		4215
	],
	"./chars/tfg002w.png": [
		27368,
		7368
	],
	"./chars/tfg003.png": [
		18430,
		8430
	],
	"./chars/tfg003w.png": [
		2259,
		2259
	],
	"./chars/tfg004.png": [
		62993,
		2993
	],
	"./chars/tfg004w.png": [
		95274,
		5274
	],
	"./chars/tfg005.png": [
		14600,
		4600
	],
	"./chars/tumbs/bdwarf001.png": [
		68713,
		8713
	],
	"./chars/tumbs/bdwarf002.png": [
		78002,
		8002
	],
	"./chars/tumbs/bdwarf002w.png": [
		84359,
		4359
	],
	"./chars/tumbs/bdwarf003.png": [
		75867,
		5867
	],
	"./chars/tumbs/bhawnthorn001.png": [
		37026,
		7026
	],
	"./chars/tumbs/bhawnthorn002.png": [
		93113,
		3113
	],
	"./chars/tumbs/bhawnthorn002w.png": [
		65314,
		5314
	],
	"./chars/tumbs/bhawnthorn003.png": [
		86864,
		6864
	],
	"./chars/tumbs/bkerala001.png": [
		30793,
		793
	],
	"./chars/tumbs/bkerala002.png": [
		16178,
		6178
	],
	"./chars/tumbs/bkerala002w.png": [
		9735,
		9735
	],
	"./chars/tumbs/bkerala003.png": [
		31003,
		1003
	],
	"./chars/tumbs/bkhotan001.png": [
		51884,
		1884
	],
	"./chars/tumbs/bkhotan002.png": [
		54535,
		4535
	],
	"./chars/tumbs/bkhotan002w.png": [
		67880,
		7880
	],
	"./chars/tumbs/bkhotan003.png": [
		2046,
		2046
	],
	"./chars/tumbs/bpitaya001.png": [
		13033,
		3033
	],
	"./chars/tumbs/bpitaya002.png": [
		98418,
		8418
	],
	"./chars/tumbs/bpitaya002w.png": [
		34823,
		4823
	],
	"./chars/tumbs/bpitaya003.png": [
		13243,
		3243
	],
	"./chars/tumbs/btfg001.png": [
		6058,
		6058
	],
	"./chars/tumbs/btfg002.png": [
		55041,
		5041
	],
	"./chars/tumbs/btfg002w.png": [
		54586,
		4586
	],
	"./chars/tumbs/btfg003.png": [
		82328,
		2328
	],
	"./chars/tumbs/dwarf001.png": [
		2209,
		2209
	],
	"./chars/tumbs/dwarf002.png": [
		44778,
		4778
	],
	"./chars/tumbs/dwarf002w.png": [
		80399,
		399
	],
	"./chars/tumbs/dwarf003.png": [
		76691,
		6691
	],
	"./chars/tumbs/dwarf003w.png": [
		72324,
		2324
	],
	"./chars/tumbs/dwarf004.png": [
		79292,
		9292
	],
	"./chars/tumbs/dwarf004w.png": [
		51609,
		1609
	],
	"./chars/tumbs/dwarf005.png": [
		31557,
		1557
	],
	"./chars/tumbs/hawnthorn001.png": [
		19050,
		9050
	],
	"./chars/tumbs/hawnthorn002.png": [
		68033,
		8033
	],
	"./chars/tumbs/hawnthorn002w.png": [
		96026,
		6026
	],
	"./chars/tumbs/hawnthorn003.png": [
		95320,
		5320
	],
	"./chars/tumbs/hawnthorn003w.png": [
		67301,
		7301
	],
	"./chars/tumbs/hawnthorn004.png": [
		74935,
		4935
	],
	"./chars/tumbs/hawnthorn004w.png": [
		26488,
		6488
	],
	"./chars/tumbs/hawnthorn005.png": [
		84942,
		4942
	],
	"./chars/tumbs/kerala001.png": [
		54065,
		4065
	],
	"./chars/tumbs/kerala002.png": [
		23898,
		3898
	],
	"./chars/tumbs/kerala002w.png": [
		55423,
		5423
	],
	"./chars/tumbs/kerala003.png": [
		41475,
		1475
	],
	"./chars/tumbs/kerala003w.png": [
		51732,
		1732
	],
	"./chars/tumbs/kerala004.png": [
		11308,
		1308
	],
	"./chars/tumbs/kerala004w.png": [
		74857,
		4857
	],
	"./chars/tumbs/kerala005.png": [
		80405,
		405
	],
	"./chars/tumbs/khotan001.png": [
		38548,
		8548
	],
	"./chars/tumbs/khotan002.png": [
		60015,
		15
	],
	"./chars/tumbs/khotan002w.png": [
		92384,
		2384
	],
	"./chars/tumbs/khotan003.png": [
		78470,
		8470
	],
	"./chars/tumbs/khotan003w.png": [
		90955,
		955
	],
	"./chars/tumbs/khotan004.png": [
		80889,
		889
	],
	"./chars/tumbs/khotan004w.png": [
		66466,
		6466
	],
	"./chars/tumbs/khotan005.png": [
		74640,
		4640
	],
	"./chars/tumbs/pitaya001.png": [
		6865,
		6865
	],
	"./chars/tumbs/pitaya002.png": [
		46970,
		6970
	],
	"./chars/tumbs/pitaya002w.png": [
		54559,
		4559
	],
	"./chars/tumbs/pitaya003.png": [
		36803,
		6803
	],
	"./chars/tumbs/pitaya003w.png": [
		27572,
		7572
	],
	"./chars/tumbs/pitaya004.png": [
		87404,
		7404
	],
	"./chars/tumbs/pitaya004w.png": [
		4617,
		4617
	],
	"./chars/tumbs/pitaya005.png": [
		99029,
		9029
	],
	"./chars/tumbs/tfg001.png": [
		83778,
		3778
	],
	"./chars/tumbs/tfg002.png": [
		97785,
		7785
	],
	"./chars/tumbs/tfg002w.png": [
		82530,
		2530
	],
	"./chars/tumbs/tfg003.png": [
		65680,
		5680
	],
	"./chars/tumbs/tfg003w.png": [
		71149,
		1149
	],
	"./chars/tumbs/tfg004.png": [
		77903,
		7903
	],
	"./chars/tumbs/tfg004w.png": [
		12448,
		2448
	],
	"./chars/tumbs/tfg005.png": [
		92806,
		2806
	],
	"./circle.png": [
		91104,
		1104
	],
	"./comingSoon.png": [
		56860,
		6860
	],
	"./divider/01.png": [
		74371,
		4371
	],
	"./divider/02.png": [
		12392,
		2392
	],
	"./divider/03.png": [
		44433,
		4433
	],
	"./divider/04.png": [
		99870,
		9870
	],
	"./divider/05.png": [
		92007,
		2007
	],
	"./divider/06.png": [
		24972,
		4972
	],
	"./divider/07.png": [
		36597,
		6597
	],
	"./divider/08.png": [
		7442,
		7442
	],
	"./error.png": [
		17376,
		7376
	],
	"./false.png": [
		11971,
		1971
	],
	"./fruits/dwarf-f.png": [
		9601,
		9601
	],
	"./fruits/hawnthorn-f.png": [
		53492,
		3492
	],
	"./fruits/kerala-f.png": [
		86017,
		6017
	],
	"./fruits/khotan-f.png": [
		46746,
		6746
	],
	"./fruits/pitaya-f.png": [
		99953,
		9953
	],
	"./fruits/tfg-f.png": [
		65104,
		5104
	],
	"./home/about.png": [
		44067,
		4067
	],
	"./home/bcn.png": [
		87797,
		7797
	],
	"./home/footerGreen.png": [
		25682,
		5682
	],
	"./home/hero/01.jpg": [
		63870,
		3870
	],
	"./home/hero/02.jpg": [
		43465,
		3465
	],
	"./home/hero/03.jpg": [
		88204,
		8204
	],
	"./home/hero/04.jpg": [
		94519,
		4519
	],
	"./home/hero/05.jpg": [
		23354,
		3354
	],
	"./home/khotan.png": [
		10651,
		651
	],
	"./home/slogan.png": [
		67220,
		7220
	],
	"./home/spacer.png": [
		23958,
		3958
	],
	"./home/timSpace.png": [
		82182,
		2182
	],
	"./icons/cmc.png": [
		97154,
		7154
	],
	"./icons/coins/bcn.png": [
		50847,
		847
	],
	"./icons/coins/tim.png": [
		37528,
		7528
	],
	"./icons/coins/trx.png": [
		13048,
		3048
	],
	"./icons/coins/usdt.png": [
		52520,
		2520
	],
	"./icons/menu/1.png": [
		93908,
		3908
	],
	"./icons/menu/Asset 21.png": [
		30790,
		790
	],
	"./icons/menu/amordadShop.png": [
		53437,
		3437
	],
	"./icons/menu/bgWallet.png": [
		99003,
		9003
	],
	"./icons/menu/decorations.png": [
		38288,
		8288
	],
	"./icons/menu/deposit.png": [
		96475,
		6475
	],
	"./icons/menu/exit.png": [
		25441,
		5441
	],
	"./icons/menu/freeze.png": [
		56708,
		6708
	],
	"./icons/menu/garden.png": [
		14298,
		4298
	],
	"./icons/menu/home.png": [
		26152,
		6152
	],
	"./icons/menu/market.png": [
		91793,
		1793
	],
	"./icons/menu/myFruits.png": [
		98298,
		8298
	],
	"./icons/menu/myProfile.png": [
		36452,
		6452
	],
	"./icons/menu/mySeeds.png": [
		21301,
		1301
	],
	"./icons/menu/rankings.png": [
		31824,
		1824
	],
	"./icons/menu/transfer.png": [
		68180,
		8180
	],
	"./icons/menu/withdraw.png": [
		52775,
		2775
	],
	"./icons/menu/xpHistory.png": [
		8561,
		8561
	],
	"./icons/noData.png": [
		26320,
		6320
	],
	"./icons/ranks/01.png": [
		99984,
		9984
	],
	"./icons/ranks/02.png": [
		65387,
		5387
	],
	"./icons/ranks/03.png": [
		1730,
		1730
	],
	"./icons/seeds/BDWARF.png": [
		96802,
		6802
	],
	"./icons/seeds/BHAWNTHORN.png": [
		31603,
		1603
	],
	"./icons/seeds/BKERALA.png": [
		24962,
		4962
	],
	"./icons/seeds/BKHOTAN.png": [
		45249,
		5249
	],
	"./icons/seeds/BPITAYA.png": [
		33442,
		3442
	],
	"./icons/seeds/BTFG.png": [
		68459,
		8459
	],
	"./icons/seeds/DWARF.png": [
		36298,
		6298
	],
	"./icons/seeds/HAWNTHORN.png": [
		48171,
		8171
	],
	"./icons/seeds/KERALA.png": [
		20058,
		58
	],
	"./icons/seeds/KHOTAN.png": [
		80313,
		313
	],
	"./icons/seeds/PITAYA.png": [
		90202,
		202
	],
	"./icons/seeds/TFG.png": [
		48499,
		8499
	],
	"./leaf.png": [
		29620,
		9620
	],
	"./level.png": [
		32756,
		2756
	],
	"./loginBack.jpg": [
		74916,
		4916
	],
	"./logo-alt.png": [
		76239,
		6239
	],
	"./logo.png": [
		62077,
		2077
	],
	"./rectBtn.png": [
		10636,
		636
	],
	"./roundBtn.png": [
		89603,
		1984
	],
	"./seedsHeader.jpg": [
		58563,
		8563
	],
	"./true.png": [
		4212,
		4212
	],
	"./underMaintenance.png": [
		45291,
		5291
	],
	"./warning.png": [
		46070,
		6070
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 85680;
module.exports = webpackAsyncContext;